<ng-container [formGroup]="formParent">
  <label
    *ngIf="label"
    [for]="id"
    [class.required]="required && !hideRequiredLabel"
    >{{ label | translate }}</label
  >
  <div class="form-field-container">
    <input
      #phone
      class="phone-input"
      [formControlName]="name"
      [(ngModel)]="value"
      [placeholder]="placeholder | translate"
      [id]="id"
      [attr.readonly]="readonly"
      [attr.aria-required]="required ? true : null"
    />
  </div>
  <ng-container *ngIf="showErrorMessages">
    <mat-error
      id="{{ id }}-required-error"
      *ngIf="ngControl.touched && ngControl?.hasError('required')"
    >
      {{ "REQUIRED" | translate }}
    </mat-error>

    <mat-error
      id="{{ id }}-phone-error"
      *ngIf="ngControl.touched && ngControl?.hasError('pattern')"
    >
      {{ hint | translate }}
    </mat-error>
  </ng-container>
</ng-container>
